import { Tag, TagProps } from "antd";
import React from "react";

export const NotAssignedTag = (props: TagProps) => {

    return <Tag color="default" {...props}>Not Assigned</Tag>;
}